import React from 'react';
import styled from 'styled-components';
import portrait from '../../icons/jednatel.jpg';
import sign from '../../icons/podpis.jpg';

export default function About() {
  return (
    <PageWrapper>
      <TextContainerLeft>
        <Text>
          <h3>O Společnosti</h3>
          <p>
            Společnost J Havel Finance s.r.o. byla založena na základě zkušeností při zprostředkování
            úvěrů ve výhradním zastoupení pro Raiffeisen stavební spořitelnu, a.s. . Během této
            činnosti jsem pozoroval principy obchodního zastoupení různých institucí a různých
            zprostředkovatelů.
          </p>
          <p>
            Nejvíce jsem narážel na to, že &#34;kolegové&#34; od nás i z různých firem řešili celé portfolio
            dané instituce, nebo dokonce více institucí najednou. Osobně jsem se rozhodl vykonávat
            čistě zaměření na na úvěry pro SVJ a BD. Tímto krokem jsem dosáhl daleko vyšší úrovně
            specializace na dané produkty. Toto užší zaměření mi následně velmi pomáhalo při
            jednáních na výborech nebo představenstvech, kde jsem potkával na zprostředkovatele z
            velkých organizací zastřešujících produkty více bank a pojišťoven a tedy celou škálu
            variant. Ale právě tento příliš velký záběr jsem viděl, jako jejich velkou chybu,
            protože se tím dostali na daleko nižší znalostí jednotlivých nabízených služeb.
            Nejednou jsem zažil, že uváděli chybné informace, či postupy při zprostředkování
            produktů.
          </p>
          <p>
            Právě tyto poznatky vedly k založení J Havel Finance s.r.o., která je od začátku své
            činnosti zaměřena jen na úvěrové produkty a jen pro právnické osoby, čímž dosahuje
            daleko vyšší úrovně specializace, než je zvykem u běžných zprostředkovatelů.
          </p>
          <p>
            Jako další důležitou záležitost vnímám komplexní péči o klienty. Bohužel je častým,
            běžným a smutným jevem, že obchodník se stará o klienta do uzavření smluv a následnou
            péči  přenechá na centrále financující instituce. S tímto postupem nesouhlasím, od mých
            prvních financování držím princip péče o klienta po celou dobu řešení dané rekonstrukce,
            či refinancování.
          </p>
          <p>
            Nyní navíc díky spolupráci s více partnery mám možnost ohlídat stav celého trhu s
            úvěrovými produkty pro SVJ a BD a mohu tento princip péče rozšířit o dohled nad produktem
            během celého období splácení a v případě změny podmínek na trhu doporučit refinancování.
          </p>
          <p>
            Vím, že díky kombinaci výše uvedených faktorů a díky zaměření na úzký segment trhu a
            produktů jsem schopen SVJ a BD poskytnout  kvalitnější a pohodlnější zajištění financování,
             či refinancování  rekonstrukcí jejich domů.
          </p>
          <SignatureWrapp>
            <Signature src={sign} />
          </SignatureWrapp>
          <Jednatel> Jednatel</Jednatel>
        </Text>
      </TextContainerLeft>
      <TextContainer>
        <TextBox>
          <Image src={portrait} />
          <Text>
            <h3>O jednateli</h3>
            <p>Bc. Jiří Havel</p>
            <p>14.7.1984</p>
          </Text>
        </TextBox>
        <Text>
          <h4>Vzdělání:</h4>
          <p>1995 - 2003 Gymnázium Františka Palackého Neratovice</p>
          <p>2003 - 2007 Škoda Auto Vysoká škola (ekonomika a management) </p>
          <h4>Pracovní zkušenosti:</h4>
          <p>2003 - 2006 AAA Auto, a.s.  - Podpora prodeje</p>
          <p>2006 - 2007 Škoda Auto, a.s. - Praxe ve výrobě</p>
          <p>2008 - 2011 KnVnet s.r.o. - Obchodní ředitel</p>
          <p>2011 - 2016 CentroNet, a.s. - Koordinátor</p>
          <p>2016 - 2019 Raiffeisen stavební spořitelna, a.s.</p>
          <p>2019 - JHavel Finance s.r.o.</p>

        </Text>
      </TextContainer>
    </PageWrapper>
  );
}

const SignatureWrapp = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const Jednatel = styled.h4`
  text-align: right;
  margin: 0;
  padding-right: 8px;
  @media(max-width: 600px) {margin-bottom: 24px;}
  @media(max-width: 450px) {margin-bottom: 0;}
`;
const Signature = styled.img``;
const Image = styled.img`
  width: 150px;
  box-shadow: 1px 3px 6px ${({ theme }) => theme.palette.black.light};
  position: absolute;
  top: 50%;
  right: 20%;
  transform: translate(0,-50%);
  transition: all .2s ease;

  @media(max-width: 1350px) {
    right: 0;
  }
  @media(max-width: 820px) {
    right: 20%;
  }
  @media(max-width: 450px) {
    position: relative;
    right: auto;
    left: auto;
    transform: translate(0,0);
  }
`;
const Text = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin: 6px 12px 0 0;
    text-align: justify;
    @media(max-width: 600px) {
      margin: 6px 0 0 0;
    }
  }
`;
const TextContainerLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  padding: 12px;

  @media(max-width: 1099px) {
    width: 50%;
  }
  @media(max-width: 820px) {
    width: 100%;
  }

  @media(max-width: 820px) {
    padding: 0 0 48px 0;
  }

`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 12px;

  @media(max-width: 820px) {
    width: 100%;
  }

  @media(max-width: 820px) {
    padding: 0 0 48px 0;
  }

`;
const TextBox = styled.div`
  display: flex;
  flex-direction: flex-end;
  align-items: center;
  position: relative;

  @media(max-width: 450px) {
    flex-direction: column;
  }
`;

const PageWrapper = styled.div`
  width: 100%;
  max-width: 1800px;
  padding: 24px;
  margin: 24px auto;
  display: flex;
  justify-content: space-around;

  @media(max-width: 1180px) {
    width: 96%;
  }

  @media(max-width: 820px) {
    flex-direction: column;
    padding: 0 24px 24px 24px;
  }

  @media(max-width: 450px) {
    padding: 0;
  }
`;
